import api from './api';
import { LoginPayload, LoginResponse } from '../types/auth';

export const authenticateTechnician = async (payload: LoginPayload): Promise<LoginResponse> => {
  return api.post<LoginResponse, LoginResponse, LoginPayload>('login', payload);
};
